import DOCUMENT_CONFIGS from './documentsVerificationConstants';

export default [
    {
        events: [
            DOCUMENT_CONFIGS.MOVED_INTO_STATE_FUTURE,
            DOCUMENT_CONFIGS.MOVED_INTO_STATE,
            DOCUMENT_CONFIGS.CHANGE_IN_ADDRESS_FUTURE,
            DOCUMENT_CONFIGS.CHANGE_IN_ADDRESS,
            
        ],
        documents: [
            {
                categoryType: DOCUMENT_CONFIGS.ADDRESS_PROOF,
                documentsQty: 3,
                documentTypes: [
                    DOCUMENT_CONFIGS.CURRENT_LEASE,
                    DOCUMENT_CONFIGS.MORTGAGE_DOCUMENT,
                    DOCUMENT_CONFIGS.UTILITY_BILLS,
                    DOCUMENT_CONFIGS.DRIVER_LICENSE,
                    DOCUMENT_CONFIGS.VOTER_CARD,
                    DOCUMENT_CONFIGS.SCHOOL_ENROLLMENT_NEW_ADDRESS,
                    DOCUMENT_CONFIGS.PREVIOUS_LEASE,
                    DOCUMENT_CONFIGS.PREVIOUS_MORTGAGE_DOCUMENT,
                    DOCUMENT_CONFIGS.PREVIOUS_DRIVER_LICENSE,
                    DOCUMENT_CONFIGS.SCHOOL_ENROLLMENT_ADDRESS,
                    DOCUMENT_CONFIGS.PREVIOUS_UTILITY_BILLS,
                    DOCUMENT_CONFIGS.PREVIOUS_VOTER_CARD,
                    DOCUMENT_CONFIGS.TERM_LETTER_COV_MOVE,
                    DOCUMENT_CONFIGS.DOC_PREMIUM_PAID_MOVE,
                    DOCUMENT_CONFIGS.HIPPA_CERTIFICATION_MOVE,
                    DOCUMENT_CONFIGS.PAY_STUB_COV_MOVE,
                    DOCUMENT_CONFIGS.OTHER_COVERAGE_DOC_MOVE,
                    DOCUMENT_CONFIGS.NO_PRIOR_COV_STATEMENT
                ],
            }
        ],
    },
    {
        events: [
            DOCUMENT_CONFIGS.MARRIAGE,
            DOCUMENT_CONFIGS.MARRIAGE_FUTURE
        ],
        documents: [
            {
                categoryType: DOCUMENT_CONFIGS.PROOF_OF_MARRIAGE,
                documentsQty: 2,
                mandatoryDocuments: [ DOCUMENT_CONFIGS.MARRIAGE_CERTIFICATE ],
                documentTypes: [
                    DOCUMENT_CONFIGS.MARRIAGE_CERTIFICATE,
                    DOCUMENT_CONFIGS.TERM_LETTER_COV_MARRIAGE,
                    DOCUMENT_CONFIGS.DOC_PREMIUM_PAID_MARRIAGE,
                    DOCUMENT_CONFIGS.HIPPA_CERTIFICATION_MARRIAGE,
                    DOCUMENT_CONFIGS.PAY_STUB_COV_MARRIAGE,
                    DOCUMENT_CONFIGS.OTHER_COVERAGE_DOC_MARRIAGE,
                    DOCUMENT_CONFIGS.NO_PRIOR_COV_STATEMENT,
                ],
            }
        ],
    },
    {
        events: [
            DOCUMENT_CONFIGS.DIVORCE,
            DOCUMENT_CONFIGS.DIVORCE_OR_ANULLMENT,
            DOCUMENT_CONFIGS.DIVORCE_OR_DEATH_OF_ENROLLEE,
            DOCUMENT_CONFIGS.DEATH
        ],
        documents: [
            {
                categoryType: DOCUMENT_CONFIGS.PROOF_OF_LOSS_OF_DEPENDENT,
                documentsQty: 1,
                documentTypes: [
                    DOCUMENT_CONFIGS.LEGAL_SEPARATION_DOC, 
                    DOCUMENT_CONFIGS.DEATH_CERTIFICATE,
                    DOCUMENT_CONFIGS.OBITUARY
                ],
            }
        ],
    },
    {
        events: [
            DOCUMENT_CONFIGS.ICHRA_SEP,
            DOCUMENT_CONFIGS.LOSS_OF_ELIGIBILITY_FOR_EMPLOYER_HEALTH_REIMBURSEMENT_ARRANGEMENT_HRA,
            DOCUMENT_CONFIGS.QSEHRA_SEP,
            DOCUMENT_CONFIGS.ICHRA_SEP_FUTURE,
        ],
        documents: [
            {
                categoryType: DOCUMENT_CONFIGS.PROOF_OF_HRA,
                documentsQty: 1,
                documentTypes: [
                    DOCUMENT_CONFIGS.HRA_EMPLOYER_NOTICE
                ],
            }
        ],
    },
    {
        events: [ DOCUMENT_CONFIGS.INCREASE_IN_SUBSIDY_EMPLOYER_PLAN_CHANGE ],
        documents: [
            {
                categoryType: DOCUMENT_CONFIGS.PROOF_OF_EMPLOYER_PLAN,
                documentsQty: 1,
                documentTypes: [
                    DOCUMENT_CONFIGS.EMPLYR_COVERAGE_OFFER_COBRA,
                    DOCUMENT_CONFIGS.LETTER_EMPLYR_COBRA,
                    DOCUMENT_CONFIGS.COBRA_THIRD_PARTY_COV,
                ],
            }
        ],
    },
    {
        events: [
            DOCUMENT_CONFIGS.EXCEPTIONAL_CIRCUMSTANCES_SYSTEM_ERROR,
            DOCUMENT_CONFIGS.EXCEPTIONAL_CIRCUMSTANCES_NATURAL_DISASTER,
            DOCUMENT_CONFIGS.ERROR_BROKER_NAVIGATOR,
            DOCUMENT_CONFIGS.ERROR_DUE_EXCHANGE,
            DOCUMENT_CONFIGS.ERROR_PLAN_DISPLAY
        ],
        documents: [
            {
                categoryType: DOCUMENT_CONFIGS.DOC_INDICATING_EXCEPTIONS,
                documentsQty: 1,
                documentTypes: [DOCUMENT_CONFIGS.REGULATORY_AGENCY_DOC],
            }
        ],
    },
    {
        events: [ DOCUMENT_CONFIGS.CHANGE_IN_INCOME ],
        documents: [
            {
                categoryType: DOCUMENT_CONFIGS.PROOF_OF_INCOME_CHANGE,
                documentsQty: 1,
                documentTypes: [ 
                    DOCUMENT_CONFIGS.EMPLYR_NOTICE_INCOME_DEC, 
                    DOCUMENT_CONFIGS.PAY_STUB_DECREASE, 
                    DOCUMENT_CONFIGS.SELF_EMPLOYED_GCI_DOC,
                    DOCUMENT_CONFIGS.TERM_PRIOR_COV_INCOME_CHANGE, 
                ],
            }
        ],
    },
    {
        events: [
            DOCUMENT_CONFIGS.CHANGE_IN_CITIZENSHIP,
            DOCUMENT_CONFIGS.CHANGE_IN_LEGAL_PRESENCE
        ],
        documents: [
            {
                categoryType: DOCUMENT_CONFIGS.PROOF_OF_CURRENT_LEGAL_STATUS,
                documentsQty: 1,
                documentTypes: [
                    DOCUMENT_CONFIGS.BIRTH_CERTIFICATE,
                    DOCUMENT_CONFIGS.CIRT_REPORTING_BIRTH,
                    DOCUMENT_CONFIGS.CERT_CITIZENSHIP,
                    DOCUMENT_CONFIGS.US_CIVIL_SERVICES_BIRTH,
                    DOCUMENT_CONFIGS.CENSUS_REC_BIRTH,
                    DOCUMENT_CONFIGS.ADOPTION_DECREE,
                    DOCUMENT_CONFIGS.UNEXP_PASSPORT,
                    DOCUMENT_CONFIGS.MEDICAL_RECORDS_BIRTH,
                    DOCUMENT_CONFIGS.MIL_RECORD_BIRTH,
                    DOCUMENT_CONFIGS.ENHANCED_DRIVER_LICENSE, //newly added
                    DOCUMENT_CONFIGS.MARINAS_ID_CARD,
                    DOCUMENT_CONFIGS.RELEGIOUS_REC_BIRTH,
                    DOCUMENT_CONFIGS.PASS_CARD,
                    DOCUMENT_CONFIGS.ABROAD_BIRTH,
                    DOCUMENT_CONFIGS.SCHOOL_REC_BIRTH,
                    DOCUMENT_CONFIGS.ACT_2000_BIRTH,
                    DOCUMENT_CONFIGS.TEMP_I551_STAMP,
                    DOCUMENT_CONFIGS.TRIBAL_BIRTH,
                    DOCUMENT_CONFIGS.I94_UNEXP_FOREIGN_PASSPORT, //newly added
                    DOCUMENT_CONFIGS.CTZN_ID_CARD,
                    DOCUMENT_CONFIGS.US_PASSPORT,
                    DOCUMENT_CONFIGS.DS2019,
                    DOCUMENT_CONFIGS.I20,
                    DOCUMENT_CONFIGS.I94,
                    DOCUMENT_CONFIGS.I94_UNEXP,
                    DOCUMENT_CONFIGS.I327,
                    DOCUMENT_CONFIGS.I551,
                    DOCUMENT_CONFIGS.I571,
                    DOCUMENT_CONFIGS.I688,
                    DOCUMENT_CONFIGS.I688A,
                    DOCUMENT_CONFIGS.I688B,
                    DOCUMENT_CONFIGS.I766,
                    DOCUMENT_CONFIGS.ADMIN_STAY_DHS,
                    DOCUMENT_CONFIGS.DOC_WITHHOLD_REMOVAL,
                    DOCUMENT_CONFIGS.I360,
                    DOCUMENT_CONFIGS.DOC_REFUGEE_SETTLEMENT
                ],
            }
        ],
    },
    {
        events: [DOCUMENT_CONFIGS.CHANGE_IN_INCARCERATION, DOCUMENT_CONFIGS.INCARCERATION],
        documents: [
            {
                categoryType: DOCUMENT_CONFIGS.PROOF_OF_INCARCERATION_STATUS,
                documentsQty: 1,
                documentTypes: [ DOCUMENT_CONFIGS.INCARCERATION_RELEASE_DOC ],
            }
        ],
    },
    {
        events: [DOCUMENT_CONFIGS.TAX_SEP_SELECT],
        documents: [
            {
                categoryType: DOCUMENT_CONFIGS.PROOF_OF_EZ_ENROLL_FORM,
                documentsQty: 1,
                documentTypes: [ DOCUMENT_CONFIGS.STATE_TAX_FORM ],
            }
        ],
    },
    {
        events: [
            DOCUMENT_CONFIGS.LOST_OTHER_MIN_ESSENTIAL_COVERAGE,
            DOCUMENT_CONFIGS.LOST_OTHER_MIN_ESSENTIAL_COVERAGE_FUTURE,
            DOCUMENT_CONFIGS.LOSS_OF_MEC,
            DOCUMENT_CONFIGS.LOSS_OF_MEC_FUTURE,
            DOCUMENT_CONFIGS.LOSS_OF_MEDICAID,
            DOCUMENT_CONFIGS.LOSS_OF_MEDICAID_FUTURE,
            DOCUMENT_CONFIGS.LOSS_OF_COVERAGE_THROUGH_EMPLOYER,
            DOCUMENT_CONFIGS.LOSS_OF_COVERAGE_THROUGH_EMPLOYER_FUTURE
        ],
        documents: [
            {
                categoryType: DOCUMENT_CONFIGS.PROOF_OF_LOSS_OF_COVERAGE,
                documentsQty: 1,
                documentTypes: [
                    DOCUMENT_CONFIGS.PRIOR_EMPLYR_LOSS_OF_COVERAGE,
                    DOCUMENT_CONFIGS.EMPLYR_COVERAGE_OFFER,
                    DOCUMENT_CONFIGS.HEALTH_INSURANCE_COVERAGE_OFFER,
                    DOCUMENT_CONFIGS.GOVT_INSURANCE_COVERAGE_OFFER
                ],
            }
        ],
    },
    {
        events: [
            DOCUMENT_CONFIGS.GAIN_COURT_APPOINTED_DEPENDENT,
            DOCUMENT_CONFIGS.ADOPTION,
        ],
        documents: [
            {
                categoryType: DOCUMENT_CONFIGS.PROOF_OF_GAIN_OF_DEPENDENT,
                documentsQty: 1,
                documentTypes: [
                    DOCUMENT_CONFIGS.COURT_ORDER_INDICATING_ADD_REMOVE,
                    DOCUMENT_CONFIGS.COURT_ORDER_CHILD_SUPPORT,
                    DOCUMENT_CONFIGS.COURT_ORDER
                ],
            }
        ],
    },
    {
        events: [
            DOCUMENT_CONFIGS.CHANGE_IN_TRIBE_STATUS,
            DOCUMENT_CONFIGS.CHANGE_IN_AI_AN_STATUS
        ],
        documents: [
            {
                categoryType: DOCUMENT_CONFIGS.PROOF_OF_TRIBAL,
                documentsQty: 1,
                documentTypes: [
                    DOCUMENT_CONFIGS.TRIBAL_CARD,
                    DOCUMENT_CONFIGS.TRIBAL_DOCUMENT,
                    DOCUMENT_CONFIGS.TRIBAL_MEMBERSHIP,
                    DOCUMENT_CONFIGS.CERT_CDIB
                ],
            }
        ],
    },
    {
        events: [
            DOCUMENT_CONFIGS.SURVIVOR_OF_DOMESTIC_ABUSE_OR_SPOUSAL_ABANDONMENT
        ],
        documents: [
            {
                categoryType: DOCUMENT_CONFIGS.PROOF_OF_DOMESTIC_VOILENCE,
                documentsQty: 1,
                documentTypes: [ DOCUMENT_CONFIGS.DOC_SUPPORTING_EVENT],
            }
        ],
    },
    {
        events: [ DOCUMENT_CONFIGS.BIRTH ],
        documents: [
            {
                categoryType: DOCUMENT_CONFIGS.PROOF_BIRTH,
                documentsQty: 1,
                documentTypes: [
                    DOCUMENT_CONFIGS.BIRTH_CERTIFICATE,
                    DOCUMENT_CONFIGS.CIRT_REPORTING_BIRTH
                ],
            }
        ],
    },
    {
        events: [ DOCUMENT_CONFIGS.UNSUPPORTED_EVENT ],
        documents: [
            {
                categoryType: DOCUMENT_CONFIGS.DOC_PROVING_EVENT,
                documentsQty: 1,
                documentTypes: [DOCUMENT_CONFIGS.DOC_SUPPORTING_EVENT],
            },
        ],
    },
];
